import { HandExtendedIcon } from './HandExtendedIcon';

/**
 * author: Michael Irigoyen
 * id 94B9D1E7-C84C-413B-B999-92BD6508D013
 * name hand-extended
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hand-extended.svg
 * tags
 */
export const HandPalmIcon = HandExtendedIcon;
export default HandPalmIcon